<template>
  <div>
    <div v-if="isOwnerOrManajemen()">
        <OwnerProfile/>
    </div>
    <div v-else-if="isPic() || (isPic() && (isDpm() || isDokter()))">
        <PicProfile/>
    </div>
    <div v-else-if="isDokter()">
        <DokterProfile/>
    </div>
    <div v-else-if="isStaff">
        <StaffProfile/>
    </div>
    <div v-else>
        <DefaultProfile/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    "OwnerProfile": () => import('./OwnerProfile.vue'),
    "PicProfile": () => import('./Pic/PicProfile.vue'),
    "DokterProfile": () => import('./Dokter/DokterProfile.vue'),
    "StaffProfile": () => import('./Staff/StaffProfile.vue'),
    "DefaultProfile": () => import('./Detail.vue'),
},
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName", "getFaskesType"]),
    isStaff() {
      return this.isPerawat() || this.isFrontDesk() || this.isKasir() || this.isApoteker()
    }
  },
  data() {
    return {

    };
  },
  methods: {
    isOwnerOrManajemen() {
        const condition1 = this.getRolesName.length == 1 && (/owner/.test(this.getRolesName) || /manajemen/.test(this.getRolesName));
        const condition2 = this.getRolesName.length == 2 && (/owner/.test(this.getRolesName) && /manajemen/.test(this.getRolesName));

        return condition1 || condition2;
    },
    isPic() {
      const condition1 =  (/pic/.test(this.getRolesName));

      return condition1;
    },
    isDokter() {
      const condition1 =  (/dokter/.test(this.getRolesName));

      return condition1;
    },
    isPerawat() {
      const condition1 =  (/perawat/.test(this.getRolesName));

      return condition1;
    },
    isFrontDesk() {
      const condition1 =  (/frontdesk/.test(this.getRolesName));

      return condition1;
    },
    isKasir() {
      const condition1 =  (/kasir/.test(this.getRolesName));

      return condition1;
    },
    isApoteker() {
      const condition1 =  (/apoteker/.test(this.getRolesName));

      return condition1;
    },
    isDpm() {
      return this.getFaskesType;
    }
  }
};
</script>

<style></style>
